import { useState, useCallback, useEffect } from "react";
import { useSnackbar } from "notistack";
import {
  fetchAllVersions,
  createVersion as apiCreateVersion,
  updateVersion as apiUpdateVersion,
} from "@accredo/fe-shared/services/consentService.js";

export function useConsentDocumentActions() {
  const { enqueueSnackbar } = useSnackbar();
  const [versions, setVersions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadVersions = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetchAllVersions();
      setVersions(response?.data || []);
    } catch {
      enqueueSnackbar("Fehler beim Laden der Versionen", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  }, [enqueueSnackbar]);

  useEffect(() => {
    loadVersions();
  }, [loadVersions]);

  const createVersion = async (versionData, file, setError = null) => {
    try {
      const result = await apiCreateVersion(versionData, file, setError);
      if (result) {
        enqueueSnackbar("Version erfolgreich erstellt", { variant: "success" });
        await loadVersions();
        return true;
      }
      return false;
    } catch (error) {
      enqueueSnackbar(error.message || "Fehler beim Erstellen der Version", {
        variant: "error",
      });
      throw error;
    }
  };

  const updateVersion = async (id, versionData, setError = null) => {
    try {
      const result = await apiUpdateVersion(id, versionData, setError);
      if (result) {
        enqueueSnackbar("Version erfolgreich aktualisiert", {
          variant: "success",
        });
        await loadVersions();
        return true;
      }
      return false;
    } catch (error) {
      enqueueSnackbar(
        error.message || "Fehler beim Aktualisieren der Version",
        { variant: "error" }
      );
      throw error;
    }
  };

  return {
    versions,
    isLoading,
    loadVersions,
    createVersion,
    updateVersion,
  };
}
